<template>
  <Vue2Pdf :filename="filename">
    <main
      class="mx-10 bg-white"
    >
      <div
        v-for="(run, index) in runs" :key="run.id">
        <div class="border border-black text-black mt-4 flex flex-col justify-between">
          <div>
            <header class="flex border-b border-black items-center p-2">
              <div class="flex-none w-1/3"><img :src="brand" alt="Logo" class="mx-auto" /></div>
              <div class="flex-auto text-center"><h1 class="font-bold text-base text-blue-400">Run Design & Layout</h1></div>
            </header>
            <div class="flex border-b border-black">
              <div class="flex-none w-1/3 p-2">
                <span class="italic">Project</span>
                <h2 class="p-1 text-base">{{ project.title }}</h2>
                <table class="table w-full text-left mx-2">
                  <tr>
                    <th class="pt-1">Project Address</th>
                    <td>{{ project.address }}</td>
                  </tr>
                  <tr>
                    <th class="pt-1">City</th>
                    <td>{{ project.city }}</td>
                  </tr>
                  <tr>
                    <th class="pt-1">State/Region</th>
                    <td>{{ project.state }}</td>
                  </tr>
                  <tr>
                    <th class="pt-1">Country</th>
                    <td>{{ project.country }}</td>
                  </tr>
                  <tr>
                    <th class="pt-1">Zip/Post Code</th>
                    <td>{{ project.zipcode }}</td>
                  </tr>
                </table>
              </div>
              <!-- project -->

              <div class="flex-auto border-l border-black p-2">
                <span class="italic">Prepared by</span>
                <table class="table w-full text-left mx-2">
                  <tr>
                    <th class="pt-1">Name</th>
                    <td>{{ user.name }}</td>
                  </tr>
                  <tr>
                    <th class="pt-1">Company</th>
                    <td>{{ user.company }}</td>
                  </tr>
                  <tr>
                    <th class="pt-1">Phone</th>
                    <td>{{ user.phone }}</td>
                  </tr>
                  <tr>
                    <th class="pt-1">Email</th>
                    <td>{{ user.email }}</td>
                  </tr>
                  <tr>
                    <th class="pt-1">Phone</th>
                    <td>{{ user.phone }}</td>
                  </tr>
                  <tr>
                    <th class="pt-1">Print Date</th>
                    <td>{{ time }}</td>
                  </tr>
                  <tr>
                    <th class="pt-1">Created</th>
                    <td>{{ project.created_at }}</td>
                  </tr>
                  <tr>
                    <th class="pt-1">Last Edit</th>
                    <td>{{ project.updated_at }}</td>
                  </tr>
                </table>
              </div>
            <!-- user -->
            </div>
            <div class="flex border-b border-black">
              <div class="flex-auto p-2">
                <table class="table w-full text-left mx-2">
                  <tr>
                    <th class="pt-1">Run Name</th>
                    <td>{{ run.name }}</td>
                  </tr>
                  <tr>
                    <th class="pt-1">System</th>
                    <td>{{ run.title }}</td>
                  </tr>
                  <tr>
                    <th class="pt-1">Grate</th>
                    <td>{{ run.description }}</td>
                  </tr>
                </table>
              </div>
              <div class="flex-auto border-l border-black p-2">
                <table class="table w-full text-left mx-2">
                  <tr>
                    <th class="pt-1">Total Run Length</th>
                    <td>{{ run.feet }} ft / {{ run.length }} m</td>
                  </tr>
                  <tr>
                    <th class="pt-1">Overall Channel Depth</th>
                    <td>{{ run.channel_depth }}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
          <!-- Run details-->

          <div class="mx-auto w-full overflow-hidden" style="height:320px; transform: scale(.80)">
            <drawing-image
              :is-mounted="isMounted"
              :plain-view="false"
              :run="run"
              :part="[]"
              :outlets="outlets"
              class=""
            />
          </div>
          <!-- Drawing -->

          <div>
            <div class="flex items-center justify-end">
              <div class="flex-none w-1/2" />
              <div class="flex-auto border-t border-l border-black p-2">
                <div class="flex items-stretch gap-1">
                  <div class="flex-none w-1/3 border-2 border-blue-600 p-2 text-center">
                    <img class="mx-auto" :src="run.system.img" :alt="run.system.name" />
                    <p class="text-blue-600 font-bold">{{ run.system.name }}</p>
                  </div>
                  <div class="flex-none w-1/3 border-2 border-blue-600 p-2 text-center">
                    <img class="mx-auto" :src="run.grate.img" :alt="run.grate.name" />
                    <p class="font-bold text-gray-600">{{ run.grate.name }}</p>
                    <p class="text-gray-500">{{ run.grate.label }}</p>
                  </div>
                  <div class="flex-none w-1/3 border-2 border-blue-600 p-2 text-center">
                    <img class="mx-auto" :src="run.outletType.img" :alt="run.outletType.name" />
                    <p class="text-blue-600 font-bold">{{ run.outletType.name }}</p>
                  </div>
                </div>
              </div>
            </div>
            <!-- summary -->

            <footer class="border-t border-black flex items-center bg-gray-100">
              <div class="flex-auto p-2">
                <img :src="brand" alt="Logo" width="100" class="mx-auto" />
              </div>
              <div class="flex-none w-1/2 p-2">
                <span class="italic">General Notes.</span>
                <p class="mt-2">Run Layout has been developed from information submitted to {{ app.name }} please verify our interpretation.</p>
              </div>
              <div class="flex-auto text-right p-2">
                {{ index + 1 }} / {{ runs.length }}
              </div>
            </footer>
          </div>
          <!-- footer -->
        </div>
        <!-- content -->
        <div v-if="index < runs.length" class="html2pdf__page-break" />
      </div>
    </main>
  </Vue2Pdf>
</template>

<script>
import Vue2Pdf from '@/Shared/Vue2Pdf'
import DrawingImage from '../Runs/Drawings/Index'

export default {
  components: {
    Vue2Pdf,
    DrawingImage,
  },
  props:{
    app: Object,
    user    : Object,
    project : Object,
    runs    : Object,
    outlets : Object,
    brand   : String,
    time    : String,
    filename: String,
  },
  data() {
    return {
      isMounted: false,
    }
  },
  mounted() {
    setTimeout(() => {
      this.isMounted = true
    }, 100)
  },
}
</script>

<style>
  html { background-color: rgba(250, 250, 250, 1); }
  body {
      font-size: 12px;
      font-family: 'quattrocento_sans', sans-serif; }
</style>
